<template>
  <base-nav class="navbar-top navbar-dark" id="navbar-main" :show-toggle-button="false" expand>
    <ul class="navbar-nav align-items-center d-none d-md-flex ml-auto">
      <li class="nav-item dropdown">
        <base-dropdown class="nav-link pr-0" v-if="user">
          <div class="media align-items-center" slot="title">
            <span class="avatar avatar-sm rounded-circle pointer-cursor">
              <img
                alt="Image placeholder"
                :src="user.profile ? user.profile : require('@/assets/default_profile_picture.png')"
              />
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span
                class="mb-0 text-sm font-weight-bold text-black pointer-cursor"
              >{{ user.firstName + " " + user.lastName }}</span>
            </div>
          </div>

          <template>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>My profile</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item pointer-cursor" @click="onLogoutClicked()">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
      </li>
    </ul>
  </base-nav>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  RESET_AUTH_STATE,
  RESET_USER_STATE,
  RESET_LIVE_STREAM_STATE,
  RESET_COMMENT_STATE,
  RESET_NOTIFICATION_STATE,
  RESET_CLUB_STATE,
  RESET_SCHEDULE_STATE,
  LOGOUT
} from '@/store/actions.type'

export default {
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: ''
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    onLogoutClicked() {
      Promise.all([
        this.$store.dispatch(RESET_AUTH_STATE),
        this.$store.dispatch(RESET_USER_STATE),
        this.$store.dispatch(RESET_LIVE_STREAM_STATE),
        this.$store.dispatch(RESET_COMMENT_STATE),
        this.$store.dispatch(RESET_NOTIFICATION_STATE),
        this.$store.dispatch(RESET_CLUB_STATE),
        this.$store.dispatch(RESET_SCHEDULE_STATE),
        this.$store.dispatch(LOGOUT)
      ]).then(() => {
        this.$router.push({ name: 'login' })
      })
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser'
    })
  }
}
</script>
<style scoped>
.pointer-cursor {
  cursor: pointer !important;
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.5) !important;
}
.navbar-dark .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.5) !important;
}
.navbar-top {
  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2),
    0 6px 20px 0 rgba(170, 170, 170, 0.19);
}
</style>
